import React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, Legend, Label, Cell } from 'recharts';
import { FigureCard } from './FigureCard';
const data = [{
  t: '60°C',
  carnot: 10.5,
  real: 3.06
}, {
  t: '70°C',
  carnot: 13.1,
  real: 4.43
}, {
  t: '80°C',
  carnot: 15.6,
  real: 6.73
}, {
  t: '90°C',
  carnot: 17.9,
  real: 9.54
}, {
  t: '100°C',
  carnot: 20.1,
  real: 12.6
}];
export function Figure4() {
  return <FigureCard number={4} title="Carnot Efficiency vs Real Efficiency Across Heat Source Temperatures" subtitle="η_real scaled by ×10⁸ for co-display. Actual gap spans ~8 orders of magnitude." caption="Carnot efficiency (navy, left axis, %) versus real measured efficiency (crimson, right axis, ×10⁻⁸ %). Even with the scaling factor applied, the real values would be invisible without it — visualising the dramatic loss chain documented in Figure 5." data-id="element-197">
      <div className="relative" data-id="element-198">
        <div className="h-[440px] w-full" data-id="element-199">
          <ResponsiveContainer data-id="element-200">
            <ComposedChart data={data} margin={{
            top: 30,
            right: 60,
            left: 30,
            bottom: 50
          }} barGap={6} data-id="element-201">
              <CartesianGrid stroke="#E5E0D6" strokeDasharray="2 4" vertical={false} data-id="element-202" />
              <XAxis dataKey="t" axisLine={{
              stroke: '#1B1B1B'
            }} tick={{
              fontSize: 12,
              fill: '#374151'
            }} data-id="element-203">
                <Label value="Heat Source Temperature, T_hot (°C)" position="bottom" offset={20} style={{
                fill: '#1B1B1B',
                fontSize: 13,
                fontFamily: 'Inter',
                fontWeight: 500
              }} data-id="element-204" />
              </XAxis>
              <YAxis yAxisId="left" domain={[0, 25]} ticks={[0, 5, 10, 15, 20, 25]} axisLine={{
              stroke: '#1A4A68'
            }} tick={{
              fontSize: 12,
              fill: '#1A4A68'
            }} tickFormatter={v => `${v}%`} data-id="element-205">
                <Label value="Carnot Efficiency, η_Carnot (%)" angle={-90} position="left" offset={10} style={{
                fill: '#1A4A68',
                fontSize: 12,
                fontFamily: 'Inter',
                fontWeight: 500,
                textAnchor: 'middle'
              }} data-id="element-206" />
              </YAxis>
              <YAxis yAxisId="right" orientation="right" domain={[0, 15]} ticks={[0, 3, 6, 9, 12, 15]} axisLine={{
              stroke: '#8B2500'
            }} tick={{
              fontSize: 12,
              fill: '#8B2500'
            }} data-id="element-207">
                <Label value="Real Efficiency, η_real  (× 10⁻⁸ %)" angle={90} position="right" offset={10} style={{
                fill: '#8B2500',
                fontSize: 12,
                fontFamily: 'Inter',
                fontWeight: 500,
                textAnchor: 'middle'
              }} data-id="element-208" />
              </YAxis>
              <Tooltip contentStyle={{
              background: '#fff',
              border: '1px solid #1B1B1B',
              fontFamily: 'Inter',
              fontSize: 12
            }} data-id="element-209" />
              <Legend verticalAlign="top" align="right" iconType="square" wrapperStyle={{
              fontFamily: 'Inter',
              fontSize: 12,
              paddingBottom: 10
            }} data-id="element-210" />

              <ReferenceLine yAxisId="left" y={8} stroke="#2E5E28" strokeDasharray="6 4" data-id="element-211">
                <Label value="Iceland 8%" position="insideLeft" offset={10} style={{
                fill: '#2E5E28',
                fontSize: 10,
                fontFamily: 'Inter'
              }} data-id="element-212" />
              </ReferenceLine>
              <ReferenceLine yAxisId="left" y={15} stroke="#EF9F27" strokeDasharray="6 4" data-id="element-213">
                <Label value="NZ 15%" position="insideLeft" offset={10} style={{
                fill: '#B45309',
                fontSize: 10,
                fontFamily: 'Inter'
              }} data-id="element-214" />
              </ReferenceLine>
              <ReferenceLine yAxisId="left" y={21} stroke="#8B2500" strokeDasharray="6 4" data-id="element-215">
                <Label value="Geysers 21%" position="insideLeft" offset={10} style={{
                fill: '#8B2500',
                fontSize: 10,
                fontFamily: 'Inter'
              }} data-id="element-216" />
              </ReferenceLine>

              <Bar yAxisId="left" dataKey="carnot" name="η_Carnot (%)" fill="#1A4A68" barSize={28} radius={[2, 2, 0, 0]} isAnimationActive={false} label={{
              position: 'top',
              fontSize: 10,
              fill: '#1A4A68',
              fontFamily: 'Inter',
              fontWeight: 600,
              formatter: (v: any) => `${v}%`
            }} data-id="element-217" />
              <Bar yAxisId="right" dataKey="real" name="η_real (×10⁻⁸ %)" fill="#8B2500" barSize={28} radius={[2, 2, 0, 0]} isAnimationActive={false} label={{
              position: 'top',
              fontSize: 10,
              fill: '#8B2500',
              fontFamily: 'Inter',
              fontWeight: 600,
              formatter: (v: any) => `${v}`
            }} data-id="element-218" />
            </ComposedChart>
          </ResponsiveContainer>
        </div>

        {/* Center annotation box */}
        <div className="absolute top-[110px] left-1/2 -translate-x-1/2 pointer-events-none" data-id="element-219">
          <div className="bg-[#FEF3C7] border-2 border-[#EF9F27] rounded-sm px-5 py-3 shadow-md text-center" data-id="element-220">
            <div className="font-sans text-[10px] uppercase tracking-[0.18em] text-[#B45309] font-bold mb-1" data-id="element-221">
              The Gap
            </div>
            <div className="font-serif text-[15px] font-bold text-[#1B1B1B] mb-2" data-id="element-222">
              ~8 orders of magnitude
            </div>
            <div className="font-mono text-[11px] text-[#1B1B1B] leading-tight" data-id="element-223">
              <div data-id="element-224">
                η<sub data-id="element-225">Carnot</sub> ≈ 15.6%
              </div>
              <div data-id="element-226">
                η<sub data-id="element-227">real</sub> ≈ 6.73 × 10⁻⁸ %
              </div>
              <div className="text-[#5B5448] italic mt-1" data-id="element-228">(at 80 °C)</div>
            </div>
          </div>
        </div>

        {/* Loss breakdown */}
        <div className="mt-6 bg-white border border-[#E5E0D6] rounded-sm p-4 mx-2" data-id="element-229">
          <div className="font-sans text-[10px] uppercase tracking-wider text-[#8B2500] font-semibold mb-2" data-id="element-230">
            Loss sources — why η_real ≪ η_Carnot
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 font-serif text-[12px] text-[#1B1B1B]" data-id="element-231">
            <div className="border-l-2 border-[#8B2500] pl-3" data-id="element-232">
              <div className="font-semibold" data-id="element-233">Incomplete vaporisation</div>
              <div className="text-[#5B5448] italic" data-id="element-234">
                Dominant loss; only ~0.1% of Q_in becomes steam.
              </div>
            </div>
            <div className="border-l-2 border-[#EF9F27] pl-3" data-id="element-235">
              <div className="font-semibold" data-id="element-236">Uninsulated tubing</div>
              <div className="text-[#5B5448] italic" data-id="element-237">
                ~20–40% steam energy radiated/conducted away.
              </div>
            </div>
            <div className="border-l-2 border-[#2E5E28] pl-3" data-id="element-238">
              <div className="font-semibold" data-id="element-239">Motor friction</div>
              <div className="text-[#5B5448] italic" data-id="element-240">
                ~30–60% of mechanical work lost in bearings.
              </div>
            </div>
            <div className="border-l-2 border-[#1A4A68] pl-3" data-id="element-241">
              <div className="font-semibold" data-id="element-242">Impedance mismatch</div>
              <div className="text-[#5B5448] italic" data-id="element-243">
                100 kΩ load vs ~10–100 Ω source; ~95% reflected.
              </div>
            </div>
          </div>
        </div>
      </div>
    </FigureCard>;
}